import styled from 'styled-components';

export const CustomAudio = styled.audio`
  width: 250px;
`;
